import { ActionReducer } from '@ngrx/store';
import { environment } from '@env/environment';

export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function(state, action) {
    const newState = reducer(state, action);
    if (!environment.production) {
      console.log(`[DEBUG] action: ${action.type}`, {
        payload: (<any>action).payload,
        oldState: state,
        newState
      });
    }
    return newState;
  };
}
